/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {
  Component,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  Directive,
  ElementRef,
  Renderer2,
} from '@angular/core';
import {CanColor, MATERIAL_COMPATIBILITY_MODE, mixinColor} from '@angular/material/core';
export class MdToolbarRow {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-toolbar-row, mat-toolbar-row',
  host: {'class': 'mat-toolbar-row'},
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdToolbarRow_tsickle_Closure_declarations() {
/** @type {?} */
MdToolbarRow.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdToolbarRow.ctorParameters;
}

/**
 * \@docs-private
 */
export class MdToolbarBase {
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(public _renderer: Renderer2,
public _elementRef: ElementRef) {}
}

function MdToolbarBase_tsickle_Closure_declarations() {
/** @type {?} */
MdToolbarBase.prototype._renderer;
/** @type {?} */
MdToolbarBase.prototype._elementRef;
}

export const /** @type {?} */ _MdToolbarMixinBase = mixinColor(MdToolbarBase);
export class MdToolbar extends _MdToolbarMixinBase implements CanColor {
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(renderer: Renderer2, elementRef: ElementRef) {
    super(renderer, elementRef);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-toolbar, mat-toolbar',
  templateUrl: 'toolbar.html',
  styleUrls: ['toolbar.css'],
  inputs: ['color'],
  host: {
    'class': 'mat-toolbar',
    'role': 'toolbar'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  viewProviders: [{provide: MATERIAL_COMPATIBILITY_MODE, useValue: true}],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
}

function MdToolbar_tsickle_Closure_declarations() {
/** @type {?} */
MdToolbar.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdToolbar.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
